import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import app from './modules/app';

Vue.use(Vuex);

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: true,
  asideShow: false,
  darkMode: true,
  viewMode: {
    sites: 'grid',
  },
  messages: {
    errors: [],
    success: [],
  },
};

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
    state.sidebarShow = sidebarOpened ? false : 'responsive';
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
    state.sidebarShow = sidebarClosed ? true : 'responsive';
  },
  set(state, [variable, value]) {
    state[variable] = value;
  },
  toggle(state, variable) {
    state[variable] = !state[variable];
  },
  setDarkMode(state, mode) {
    state.darkMode = mode;
  },
  setSidebarMinimize(state, mode) {
    state.sidebarMinimize = mode;
  },
  setAsideShow(state, mode) {
    state.asideShow = mode;
  },
  setViewModeSites(state, viewModeSites) {
    state.viewMode.sites = viewModeSites;
  },
  setViewMode(state, viewMode) {
    state.viewMode = viewMode;
  },
  openSideBar(state) {
    state.asideShow = true;
  },
  addErrorMessage(state, message) {
    state.messages.errors.push(message);
  },
  addSuccessMessage(state, message) {
    message.autohide = 5000;
    state.messages.success.push(message);
  },
};

const store = new Vuex.Store({
  // strict: true,  // process.env.NODE_ENV !== 'production',
  state,
  actions,
  getters,
  modules: {
    app,
  },
  mutations,
});

export default store;
